import React from 'react';

import { Button, Box, Typography, Modal } from '@mui/material';

import UnsubscribeIcon from '../../../../common/assets/icons/unsubscribe_icon.svg';
import './SubscriptionPurchasedModal.scss';

const modalStyle = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
  borderRadius: 6,
  p: 4,
  textAlign: 'center',
  minWidth: 280,
  maxWidth: 460,
  paddingLeft: 10,
  paddingRight: 10,
};

type Props = {
  open: boolean;
  onClose: () => void;
};

const UnsubscribeFirstModal: React.FC<Props> = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <div>
          <img src={UnsubscribeIcon} alt='Unsubscribe' />
          <Typography fontSize={16} sx={{ mt: 1, mb: 1 }}>
            You already have an active subscription.
          </Typography>
          <Typography fontSize={16} sx={{ mt: 2, mb: 2 }}>
            To buy a different subscription, please cancel the current one
            first.
          </Typography>
          <Button
            onClick={onClose}
            variant='contained'
            color='primary'
            disableElevation
            sx={{
              width: '100%',
              height: 48,
              marginTop: '20px',
              borderRadius: '15px',
            }}
          >
            <Typography color='white'>OK</Typography>
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default UnsubscribeFirstModal;
